import React, { Component } from 'react';
import { trimText } from '../utils/textModifications';




export class Result extends Component {

  get_link = () => {
    const lecture = this.props.lecture;

    if(lecture.pdf){
    return lecture.pdf;
    }else if (lecture.url) {
      return lecture.url;
    }else {
      return '#';
    }
  }

  render() {
    const lecture = this.props.lecture;

    return (
      <a href={ this.get_link() } target="_blank" rel="noopener noreferrer" className="paul-search-result">
        <div className="listResult mb-3 bg-white rounded shadow-sm">

          <div className="p-3 border-bottom">
            <h5 className="mb-2">
              { lecture.type === 'pdf' && <i className="fas fa-file-pdf mr-2"></i> }
              {trimText(lecture.title, 65)}
            </h5>
            {lecture.description &&
              <small className="d-block align-self-center text-body">
                { trimText(lecture.description, 180) }
              </small>
            }
          </div>
          <div className="d-block d-md-flex justify-content-between align-items-center">

            <div className="d-none d-sm-block">
              <div className="d-flex align-items-center px-3 py-2">
                <img src={lecture.favicon} alt={lecture.organisation} className="mr-2" style={{ width: 16, height: 'auto' }}/>
                <small className="text-body">{lecture.organisation}</small>
              </div>
            </div>

            <div className="d-flex justify-content-start justify-content-sm-end">
              { lecture.language &&
                <div className="d-flex justify-content-start justify-content-sm-end align-items-center px-3 py-2" style={{ minWidth: '4rem' }}>
                  <small className='text-muted text-uppercase font-weight-bold' title={"Sprache: "+lecture.language}>{lecture.language}</small>
                </div>
              }
              { lecture.num_pages &&
                <div className="d-flex justify-content-end align-items-center px-3 py-2" style={{ minWidth: '6.5rem' }}>
                  <small className='text-secondary font-weight-bold' title={lecture.num_pages+" Seiten"}>{lecture.num_pages} <span className="font-weight-normal">Seiten</span></small>
                </div>
              }
              <div className="d-flex justify-content-end align-items-center px-3 py-2" style={{ minWidth: '5rem' }}>
                <small className='text-secondary font-weight-bold'>{lecture.year}</small>
              </div>
            </div>

            <div className="d-block d-sm-none border-top">
              <div className="d-flex align-items-center px-3 py-2">
                <img src={lecture.favicon} alt={lecture.organisation} className="mr-2" style={{ width: 16, height: 'auto' }}/>
                <small className="text-body">{lecture.organisation}</small>
              </div>
            </div>


          </div>
        </div>
      </a>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Result.js